import PropTypes from "prop-types";
import React from "react";
import { Accordion, Card } from "react-bootstrap";
import Status from "../../../components/status-indicator/Status";
import Priority from "../../../components/priority/priority";
import ViewMembersPanelNew from "../../../components/view-members-new/view-members-new";
import ProgressPill from "../dashboard-shared/progress-pill/progress-pill";

const DashboardEmailPerformance = (props) => {
  const items = props.items;

  if (items != null) {
    return (
      <div className="new-dashboard table-wrapper">
        <div className="DashboardTableWrapper">
          <table>
            <thead>
              <tr className="DashboardTableHeader">
                <th className="DashboardTableTitle">
                  Email Tasks - Performance
                </th>
              </tr>
            </thead>
          </table>
          <div>
            <Accordion>
              <Card style={{ backgroundColor: "darkgray" }}>
                <Accordion.Toggle as={Card.Header}>
                  <div className="row">
                    <div
                      className="col-md-4 text-left"
                      style={{ color: "white" }}
                    >
                      Project Name
                    </div>
                    <div className="col-md-2" style={{ color: "white" }}>
                      Avg. Response Time
                    </div>
                    <div className="col-md-2" style={{ color: "white" }}>
                      Avg. Task Completion Time
                    </div>
                    <div className="col-md-2" style={{ color: "white" }}>
                      Total Task Completion Time
                    </div>
                    <div className="col-md-1" style={{ color: "white" }}>
                      Ave. Number of Responses
                    </div>
                    <div className="col-md-1" style={{ color: "white" }}>
                      Total Number of Emails
                    </div>
                  </div>
                </Accordion.Toggle>
              </Card>
              {items.map((m) => {
                return (
                  <Card className="noOverflow" key={m?.Id}>
                    <Accordion.Toggle as={Card.Header} eventKey={m.Id}>
                      <div className="row">
                        <div className="col-md-4 text-left">{m.Name}</div>
                        <div className="col-md-2">{m.ResponseTimeAverage}</div>
                        <div className="col-md-2">
                          {m.CompletionTimeAverage}
                        </div>
                        <div className="col-md-2">{m.CompletionTimeTask}</div>
                        <div className="col-md-1">{m.ResponseCountAverage}</div>
                        <div className="col-md-1">{m.ResponseCountTotal}</div>
                      </div>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey={m.Id}>
                      <Card.Body>
                        <table>
                          <thead>
                            <tr>
                              <th className="text-left pl-2">Task</th>
                              <th>Status</th>
                              <th>Last Activity</th>
                              <th>Priority</th>
                              <th className="text-left">Actionable By</th>
                              <th className="text-left">Due Date</th>
                            </tr>
                          </thead>
                          <tbody>
                            {m.Tasks.map((n) => {
                              return (
                                <tr key={n?.Id}>
                                  <td className="text-left pl-2">{n.Name}</td>
                                  <td>
                                    <Status
                                      status={n.Status}
                                      statusEmail={n.StatusEmail}
                                    />
                                  </td>
                                  <td>{n.LastActivityString}</td>
                                  <td>
                                    <Priority priority={n.Priority} />
                                  </td>
                                  <td className="text-left">
                                    <ViewMembersPanelNew
                                      taskType={n.TaskTypeId}
                                      UserID={n.CreatedById}
                                      members={n.Members}
                                    ></ViewMembersPanelNew>
                                  </td>
                                  <td className="text-left">
                                    <ProgressPill
                                      start={n.Added}
                                      end={n.DateDue}
                                      sortBy={"upcoming due dates"}
                                    />
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                );
              })}
            </Accordion>
          </div>
        </div>
      </div>
    );
  }
  return null;
};

DashboardEmailPerformance.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
};

export default DashboardEmailPerformance;
